import React from 'react';
import { useDispatch, toast, useState } from '../../Data/Imports';
import LOGO from '../../assets/logo2.png';
import { signin } from '.././../Redux/features/auth/authSlice';

const inputFields = [
	{
		id: 1,
		name: 'EmailId',
		type: 'email',
		label: 'Email Id',
		placeholder: 'Enter your email address',
	},
	{
		id: 2,
		name: 'PWD',
		type: 'password',
		label: 'Password',
		placeholder: 'Enter your password',
	},
];

const Login = () => {
	const [loginData, setLoginData] = useState({ EmailId: '', PWD: '' });
	const [error, setError] = useState(null);
	const dispatch = useDispatch();

	const handleChange = (e) => {
		setLoginData({ ...loginData, [e.target.name]: e.target.value });
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		setError(null);
		if (!loginData.EmailId || !loginData.PWD) {
			setError('Please provide both email and password');
			return;
		}
		try {
			dispatch(signin(loginData)).then((response) => {
				if (response.type === '/signin/fulfilled') {
					toast.success(response.payload.message);
					window.location.href = '/read-logs';
				} else if (response.type === '/signin/rejected') {
					toast.error(response.payload);
				}
			});
		} catch {
			toast.error('Something went wrong. Please try again later.');
		}
	};
	return (
		<div className='w-full h-screen flex justify-center items-center px-4 sm:px-8 md:px-16'>
			<div className='sm:px-6 sm:py-12 px-3 py-10 rounded-lg text-black w-full max-w-[500px] flex flex-col gap-3 border-b-[14px] border-[#A9C46C] bg-gray-100'>
				<img src={LOGO} className=' w-80 mx-auto' alt='GLOBAL ALUMINIUM PRIVATE LIMITED LOGO' />
				<h1 className='text-center text-[#3E435DD9] text-2xl sm:text-3xl font-bold mb-4'>Login</h1>
				<form className='sm:px-10 px-5' onSubmit={handleSubmit}>
					{inputFields.map((field) => (
						<div key={field.id}>
							<label className='text-lg block my-3'>{field.label}</label>
							<input
								type={field.type}
								name={field.name}
								value={loginData[field.name]}
								onChange={handleChange}
								placeholder={field.placeholder}
								className='w-full px-4 py-2 rounded-md border text-[#808080] focus:outline-[#808080] focus:outline-2'
							/>
						</div>
					))}

					<div className='flex justify-center my-5'>
						<button type='submit' className='px-4 py-2 rounded-md w-fit text-white bg-[#A9C46C] '>
							Login
						</button>
					</div>
					{error && <p className='text-sm text-center text-red-500'>{error}</p>}
				</form>
			</div>
		</div>
	);
};

export default Login;
